module.exports = __webpack_public_path__ + "img/ssbg6.920726c9.jpg";